/**
 * BARLINE — Cart pop animation
 * Listens for cart update events and fires a bounce animation
 * on the cart icon + badge.
 */
(function () {
  'use strict';

  function popCartIcon() {
    // Target the cart icon wrapper and the bubble
    const targets = document.querySelectorAll(
      '.header-actions__cart-icon, .cart-bubble'
    );
    targets.forEach(function (el) {
      // Remove first so re-triggering replays the animation
      el.classList.remove('barline-cart-pop');
      // Force reflow to restart the animation
      void el.offsetWidth;
      el.classList.add('barline-cart-pop');
      el.addEventListener(
        'animationend',
        function () {
          el.classList.remove('barline-cart-pop');
        },
        { once: true }
      );
    });
  }

  // Horizon / Dawn emit 'cart:refresh' on the document after cart changes
  // Horizon also dispatches a custom 'cart:updated' event
  var cartEvents = [
    'cart:refresh',
    'cart:updated',
    'theme:cart:add',
    'dispatch:cart:refresh',
  ];

  cartEvents.forEach(function (evt) {
    document.addEventListener(evt, popCartIcon);
  });

  // Fallback: intercept the native Shopify /cart/add.js XHR via fetch patching
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var promise = _fetch.apply(this, args);
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (url && url.indexOf('/cart/add') !== -1) {
      promise.then(function (response) {
        if (response.ok) {
          // Small delay so the bubble count has updated in the DOM
          setTimeout(popCartIcon, 150);
        }
        return response;
      });
    }
    return promise;
  };
})();
